import { render, staticRenderFns } from "./MapLayerLegendPanel.vue?vue&type=template&id=490b2262&scoped=true&"
import script from "./MapLayerLegendPanel.vue?vue&type=script&lang=js&"
export * from "./MapLayerLegendPanel.vue?vue&type=script&lang=js&"
import style0 from "./MapLayerLegendPanel.vue?vue&type=style&index=0&id=490b2262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b2262",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VCard,VChip,VChipGroup,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('490b2262')) {
      api.createRecord('490b2262', component.options)
    } else {
      api.reload('490b2262', component.options)
    }
    module.hot.accept("./MapLayerLegendPanel.vue?vue&type=template&id=490b2262&scoped=true&", function () {
      api.rerender('490b2262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MapLayerLegendPanel.vue"
export default component.exports